module.exports = __webpack_public_path__ + "static/media/JSNLC4.579132d9.png";